/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rowrequestcompanionshint3Inputs */

const en_rowrequestcompanionshint3 = /** @type {(inputs: Rowrequestcompanionshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every companion needs a spot.`)
};

const de_rowrequestcompanionshint3 = /** @type {(inputs: Rowrequestcompanionshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Begleitung braucht einen Platz.`)
};

/**
* | output |
* | --- |
* | "Every companion needs a spot." |
*
* @param {Rowrequestcompanionshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rowrequestcompanionshint3 = /** @type {((inputs?: Rowrequestcompanionshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rowrequestcompanionshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rowrequestcompanionshint3(inputs)
	return de_rowrequestcompanionshint3(inputs)
});
export { rowrequestcompanionshint3 as "rowRequestCompanionsHint" }